import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import {
    Grid,
    makeStyles,
    DialogTitle,
    Dialog,
    DialogActions,
    DialogContent,
    IconButton,
    Button,
    InputAdornment,
    Divider
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import {
    TextField,
    Checkboxes,
    Radios,
    Select,
    DatePicker,
    TimePicker,
    Switches,
    Autocomplete
} from 'mui-rff';
import { Form, Field } from 'react-final-form';
import * as logger from '../../../logger';
import TextInputState from '../Inputs/TextInputState';

const useStyles = makeStyles((theme) => ({
    paper1: {
        borderRadius: 8
    },
    paperWidth: {
        width: 460,
        maxWidth: 460
    },
    dialogTitleV1: {
        paddingLeft: 24,
        paddingRight: 12,
        paddingTop: 12,
        paddingBottom: '12px !important',
        '& .MuiTypography-root': {
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
        }
    },
    closeButton: {
        color: '#9ea0a5'
    },
    divTitle: {
        fontSize: 20,
        fontWeight: 500
    },
    dialogContentV1: {
        padding: 24
    },
    daV1: {
        paddingLeft: 30,
        paddingRight: 30,
        paddingTop: 21,
        paddingBottom: 21
    },
    closeButtonV1: {
        borderRadius: 4,
        textTransform: 'capitalize',
        fontSize: 14,
        fontWeight: 500,
        paddingLeft: 19.5,
        paddingRight: 19.5,
        paddingTop: 7,
        paddingBottom: 7,
        backgroundImage: 'linear-gradient(to top, #f6f7f9, #ffffff) !important',
        marginRight: 16,
        '&:hover': {
            backgroundImage: 'linear-gradient(to top, #f6f7f9, #ffffff) !important'
        }
    },
    confirmButton: {
        borderRadius: 4,
        backgroundColor: '#5170f0',
        color: 'white',
        textTransform: 'capitalize',
        fontSize: 14,
        fontWeight: 500,
        paddingTop: 7,
        paddingBottom: 7,
        paddingLeft: 35,
        paddingRight: 35,
        '&:hover': {
            backgroundColor: '#5170f0'
        }
    },
    divTitleV1: {
        color: '#6b778c',
        fontSize: 12
    },
    textNote: {
        borderRadius: 4,
        marginTop: 6
    }
}));

const BiltyEditTermsDialog = ({ open, onClose, onConfirm, user, trip, termsData }) => {

    let submit;

    const classes = useStyles();

    const [dialogOpen, setDialogOpen] = useState(open);
    const [termsValue, setTermsValue] = useState("");

    const elrId = user && user.singleTripData && user.singleTripData.elr_id ? user.singleTripData.elr_id : "";
    const elrData = trip && trip.elrInfo ? trip.elrInfo : {};

    useEffect(() => {

        if (termsData) {
            setTermsValue(termsData);
        } else if (trip && trip.elrLoadData && trip.elrLoadData.terms_and_conditions) {
            setTermsValue(trip.elrLoadData.terms_and_conditions);
        } else if (elrData && elrData.terms_and_conditions) {
            setTermsValue(elrData.terms_and_conditions);
        }

    }, [])

    const initialValues = {
        terms: termsValue
    }

    const getFormFields = (values) => {
        return [
            {
                size: 12,
                visible: true,
                field: (
                    <>
                        <div>
                            <div className={classes.divTitleV1}>Terms and Conditions</div>
                            <TextInputState
                                name="terms"
                                variant="outlined"
                                size="small"
                                margin="normal"
                                multiline={true}
                                rows={6}
                                rowsMax={6}
                                className={classes.textNote}
                                onChange={(e) => setTermsValue(e.target.value)}
                            />
                        </div>
                    </>
                )
            }
        ]
    }

    const handleClose = () => {
        setDialogOpen(false);
        onClose();
    }

    const validate = values => {
        const errors = {};

        return errors
    }

    const onSubmit = values => {
        onConfirm(values.terms);
    }


    return (
        <>
            <Dialog fullWidth={true} maxWidth={'sm'}
                onClose={handleClose} disableEscapeKeyDown={true} disableBackdropClick={true} open={dialogOpen} classes={{ paper: classes.paper1, paperWidthSm: classes.paperWidth }}>

                <DialogTitle className={classes.dialogTitleV1}>
                    <div className={classes.divTitle}>
                        Edit Terms & Conditions
                    </div>
                    <IconButton onClick={() => { handleClose() }} className={classes.closeButton}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <DialogContent dividers className={classes.dialogContentV1}>
                    <Form
                        onSubmit={onSubmit}
                        initialValues={initialValues}
                        validate={validate}
                        id="myForm"
                        render={({ handleSubmit, form, submitting, pristine, values }) => {
                            submit = handleSubmit
                            return (
                                <form onSubmit={handleSubmit} noValidate id="myForm">
                                    <Grid container alignItems="flex-start">
                                        {getFormFields(values).map((item, idx) => item.visible ? (
                                            <Grid item xs={item.size} key={idx}>
                                                {item.field}
                                            </Grid>
                                        ) : null)}
                                    </Grid>
                                </form>
                            )
                        }}
                    />
                </DialogContent>

                <DialogActions className={classes.daV1}>
                    <Button variant="contained" className={classes.closeButtonV1} onClick={() => { handleClose() }}>
                        Close
                    </Button>
                    <Button variant="contained" className={classes.confirmButton} type="submit"
                        onClick={event => {
                            submit(event)
                        }}
                    >
                        Save
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({

});
export default connect(mapStateToProps, mapDispatchToProps)(BiltyEditTermsDialog)